<template>
  <el-drawer title="Converse com os nossos atendentes" class="chat" :visible.sync="drawer" direction="rtl" size="520px">
    <div class="chat-body">
      <DepartmentChat ref="department" v-model="department" :current="department" v-if="connected === false"
        @selected="update" />
      <chat-list :msgs="msgData" :userId="userId"></chat-list>
      <chat-form state="customer" :disabled="connected === false && department === ''" @chat="sendMessage"
        @close="close"></chat-form>
    </div>
  </el-drawer>
</template>

<script>
import ChatList from "./components/ChatList";
import ChatForm from "./components/ChatForm";
import DepartmentChat from '@/xpost/views/register/department/DepartmentChat'
import { DateTime, Settings } from 'luxon';
Settings.defaultLocale = 'pt-br';
Settings.defaultZone = 'America/Sao_Paulo';

export default {
  props: ["socket", "username", "userId"],
  data() {
    return {
      drawer: false,
      department: '',
      color: '#fff',
      connected: false,
      msgData: [],
    };
  },
  components: {
    ChatList,
    ChatForm,
    DepartmentChat,
  },
  methods: {
    update(data) {
      const departmentData = this.$refs.department.get(data);
      if (departmentData) this.color = departmentData.color;
      this.department = data;
    },
    open() {
      this.drawer = true;
    },
    clear() {
      this.msgData = [];
    },
    close() {
      this.connected = false;
      this.department = '';
      this.socket.emit('chat-close', this.userId);
    },
    received(type, data, connected) {
      this.msgData.push(data);
      if (type === 'info') {
        console.log(type, data);
        this.connected = connected;
      } else if (!this.department) this.department = data.department;

      setTimeout(() => {
        const element = document.getElementById("chat__body");
        if (element) element.scrollTop = element.scrollHeight;
      }, 0);
    },
    sendMessage(msg) {
      const now = DateTime.now().setZone('America/Sao_Paulo').setLocale('pt-br').toFormat('HH:mm')
      const data = {
        message: msg,
        userId: this.userId,
        username: this.username,
        department: this.department,
        color: this.color,
        time: now,
      }
      this.msgData.push(data);

      if (this.connected) this.socket.emit('chat-message', data);
      else this.socket.emit('chat-queue', data);

      setTimeout(() => {
        const element = document.getElementById("chat__body");
        element.scrollTop = element.scrollHeight;
      }, 0);
    },
  },
};
</script>

<style scoped>
#el-drawer__title {
  margin-bottom: 2px !important;
}

.chat {
  margin: 20px;
  border-radius: 15px;
}


.chat-body {
  margin: 10px;
  height: 95%;
  flex-direction: column;
  display: flex;
  justify-content: space-between;

}

.chat__header {
  background: #ffffff;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.05);
  border-radius: 24px 24px 0px 0px;
  padding: 1.8rem;
  font-size: 16px;
  font-weight: 700;
}

.chat.el-drawer__open.el-drawer {
  border-radius: 15px !important;
  background-color: aqua !important;
}

.chat__header__greetings {
  color: #292929;
}
</style>